import axios from 'axios'
import Cookie from 'js-cookie'

const getToken = async (fource)=>{
    let ckToken = Cookie.get('jw-token')
    let token = fource ? '' : ckToken
    if(token){
        token = JSON.parse(token)
    }else{
        //重新读取Token
        const ajax = axios.create({
            baseURL: process.env.VUE_APP_SXURL,
            timeout: 5000 // request timeout
        })
        ajax.interceptors.request.use(
            async config => {
                if(ckToken){
                    ckToken = JSON.parse(ckToken)
                    config.headers['token'] = ckToken.jwt
                }
                return config
            }
        )
        let res = await ajax.get('/base/token')
        token = res.status == 200 ? res.data.data : '';
        Cookie.set('jw-token', token, { expires: 1 })
    }
    
    return token
}

export default getToken